import { get, post } from '@/service/request';
const url = 'api';

// 手機e方便、SCV SSO API
export function postSSOLogin(data) {
    return post(`${url}/auth/ssoLogin`, data);
}

// 擴大給付
export function postPayAccSSOLogin(data) {
    return post(`${url}/auth/payAccSsoLogin`, data);
}

// 登出 API
export function getLogout() {
    return get(`${url}/logout`);
}
